import React, { useEffect, useRef, useState } from "react";
import EditSeries from "../EditEpisode";
import MenuDropdown from "modules/video/components/MenuDropdown";
import { SmallScreenModel } from "components";
import ConfirmationDialogMsg from "modules/video/components/ConfirmationDialogMsg";
import { connect, useSelector } from "react-redux";
import { deleteVideoEpisode } from "../../store/action";
import { VideoEpisodeProps } from "../../store/actionType";
import EpisodeFolderCard from "./EpisodeFolderCard";
import { Authorities } from "props/authoritries";
import { useUser } from "utils/helpers/UserContext";
import { SuperAdminStatusEnum } from '../../../../../props/enum';

interface EpisodeProps {
  episodeData: VideoEpisodeProps;
  episodeId: string;
  onClick: () => void;
}
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & EpisodeProps;
const EpisodeCard: React.FC<Props> = ({
  episodeData,
  onClick,
  onDeleteVideoEpisode,
  episodeId,
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isEidtFormOpen, setIsEidtFormOpen] = useState(false);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const [deleteError, setDeleteError] = useState(null);
  const closeModal = () => {
    setIsEidtFormOpen(false);
  };
  const videoEpisodeState = useSelector(
    (state: any) => state.videoEpisodes?.videoEpisodeState
  );
  const handleMenuClick = (e: any) => {
    e.stopPropagation();
    setIsMenuOpen(!isMenuOpen);
  };

  const handleSeriesClick = () => {
    if (!isMenuOpen) {
      onClick();
    } else {
      setIsMenuOpen(!isMenuOpen);
    }
  };
  const handleDeleteEpisode = (e: any) => {
    e.stopPropagation();
    onDeleteVideoEpisode(episodeData.id.toString(), episodeData.id.toString());
  };

  const toggleEditModal = () => {
    setIsEidtFormOpen(!isEidtFormOpen);
  };

  const toggleDeleteDialog = () => {
    setIsDeleteDialogOpen(!isDeleteDialogOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event: { target: any }) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
  useEffect(() => {
    setDeleteError(videoEpisodeState.error);
    if (videoEpisodeState.error) {
    } else {
      setIsDeleteDialogOpen(false);
    }
  }, [videoEpisodeState.error]);
  const { authUser, action, superAdmin } = useUser();
  const isPermitted =
    authUser &&
    (superAdmin === SuperAdminStatusEnum.SuperAdmin  ||
      action?.includes(Authorities.UPDATE_EPISODE));
  return (
    <>
      <EpisodeFolderCard
        episodeData={episodeData}
        clickedFolder={handleSeriesClick}
        clickedMenu={handleMenuClick}
      >
        {isMenuOpen && (
          <>
            {isPermitted ? (
              <MenuDropdown
                clickedEdit={toggleEditModal}
                copyId={episodeData.id}
                clickedDelete={toggleDeleteDialog}
              />
            ) : (
              <div className="text-primary-400 text-center h-[30vh] w-[20vw] flex justify-center items-center">
                You don't have the permission.
              </div>
            )}
          </>
        )}
      </EpisodeFolderCard>
      <SmallScreenModel
        showModal={isEidtFormOpen}
        setShowModal={setIsEidtFormOpen}
      >
        <EditSeries closeModal={closeModal} episodeData={episodeData} />
      </SmallScreenModel>
      <SmallScreenModel
        showModal={isDeleteDialogOpen}
        setShowModal={setIsDeleteDialogOpen}
      >
        <ConfirmationDialogMsg
          title={"Delete Series"}
          message={"Are you sure you want to delete?"}
          onConfirm={handleDeleteEpisode}
          onCancel={toggleDeleteDialog}
          folderName={episodeData.label}
          error={deleteError}
        />
      </SmallScreenModel>
    </>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  onDeleteVideoEpisode: (episode_id: string, folder_id: string) =>
    dispatch(deleteVideoEpisode(episode_id, folder_id)),
});

export default connect(null, mapDispatchToProps)(EpisodeCard);
